import permissionsApi from '../../../services/plataforma/permissions';

export default {
  getByFunctionId(_, id) {
    return permissionsApi.getByFunctionId(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  link(_, { functionId, permissionId }) {
    return permissionsApi.link(functionId, permissionId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  unlink(_, { functionId, permissionId }) {
    return permissionsApi.unlink(functionId, permissionId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  }
};
